import script from "./service-tag.vue?vue&type=script&lang=ts&setup=true"
export * from "./service-tag.vue?vue&type=script&lang=ts&setup=true"

import "./service-tag.vue?vue&type=style&index=0&id=5ad93b4b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ad93b4b"]])

export default __exports__